import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { IBaseResponse } from '@carm/_utils/models';
import { environment } from 'src/environments/environment';
import { IClearDebitItem, IClearDebitsPost, IDebitListResponse, PaymentContext } from '../models';
import { LoaderSpinnerTypes } from '@carm/_core';

@Injectable()
export class PaymentsService extends BaseApiService {

  constructor(protected injector: Injector) {
    super(injector);
  }

  public getDebitList(
    paymentContext: PaymentContext,
    draftId?: string,
    contextProgram?: string
  ): Observable<IDebitListResponse> {

    const baseUrl = !!contextProgram && paymentContext !== PaymentContext.Orphan && !!draftId
    ? `${this.endPointB}/payments/${draftId}`
    : this.getBaseUrl(paymentContext, draftId);
    const endPoint = `${baseUrl}/debits`;
    return this.httpAuthGet<IDebitListResponse>(endPoint, null, LoaderSpinnerTypes.AgGrid);
  }

  public makePayment(
    availableCredit: number,
    appliedCredit: number,
    paymentEntries: IClearDebitItem[],
    paymentContext: PaymentContext,
    draftId?: string,
    contextProgram?: string
  ): Observable<IBaseResponse> {
    const baseUrl = contextProgram && paymentContext !== PaymentContext.Orphan && !!draftId
    ? `${this.endPointB}/payments/${draftId}`
    : this.getBaseUrl(paymentContext, draftId);

    const endPoint = `${baseUrl}/clearDebits`;

    const body: IClearDebitsPost = {
      appliedCredit,
      availableCredit,
      paymentEntries,
    };

    return this.httpAuthPost<IBaseResponse>(endPoint, body);
  }

  private getBaseUrl(context: PaymentContext, draftId?: string): string {
    const paymentDraftUrl = !!draftId ? `payments/${draftId}` : '/payments';
    switch (context) {
      case PaymentContext.Business:
        return `${this.endPointB}/${paymentDraftUrl}`;
      case PaymentContext.Program:
        return `${this.endPointBP}/payments`;
      case PaymentContext.Orphan:
        return `${environment.baseApiUrls}/${paymentDraftUrl}`;
    }
  }
}
